import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/recipe/[recipeId]/RecipeViewClient.tsx");
